import { Dim, Entity } from '../../models';
import { getReceptorDims, getReceptorY } from '../../helpers';
import Stopwatch from '../renderers/Stopwatch';

export default (windowDims: Dim, inputMode: string, time: number): Entity => {
  const receptorDims = getReceptorDims(windowDims);
  const receptorY = getReceptorY(windowDims, receptorDims, inputMode);

  return {
    dims: { w: (receptorDims.w * 2) / 3, h: (receptorDims.h * 3) / 7 },
    getPos: () => ({
      x: windowDims.w / 2,
      y: receptorY + receptorDims.h,
    }),
    time,
    renderer: Stopwatch,
  };
};
